import React, { ChangeEvent, useState } from 'react'
import { IProps } from './index'
import cn from 'classnames'
import { LegacyColor } from '../../utils'

export const Toggle: React.FC<IProps> = ({
  checked: checkedProp,
  onChange: onChangeProp,
  defaultChecked,
  disabled,
  checkBgColor = LegacyColor.Black,
  uncheckBgColor = LegacyColor.Gray,
  ...rest
}) => {
  const [checkedState, setCheckedState] = useState(!!defaultChecked)

  const isControlled = typeof checkedProp !== 'undefined'

  const isChecked = isControlled ? checkedProp : checkedState

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      return
    }

    if (!isControlled) {
      setCheckedState(event.target.checked)
    }

    onChangeProp?.(event)
  }

  const toggleClasses = cn('toggle', {
    'toggle--checked': isChecked,
    'toggle--disabled': disabled,
  })
  const thumbClasses = cn('toggle__thumb', {
    'toggle__thumb--checked': isChecked,
  })

  return (
    <label className="toggle__wrapper">
      <input
        type="checkbox"
        onChange={handleOnChange}
        className="screen-readers-only toggle__checkbox"
        defaultChecked={defaultChecked}
        disabled={disabled}
        role="switch"
        aria-checked={isChecked}
        checked={isChecked}
        {...rest}
      />

      <span className={toggleClasses} aria-hidden="true">
        <span className={thumbClasses} />
      </span>

      <style jsx>{`
        .toggle {
          background: ${uncheckBgColor};
          border: 2px solid ${uncheckBgColor};
          &--checked {
            background: ${checkBgColor};
            border: 2px solid ${checkBgColor};
          }
        }
      `}</style>

      <style jsx>
        {`
          .toggle {
            display: inline-flex;
            height: 20px;
            width: 33px;
            border-radius: 20px;
            cursor: pointer;
            position: relative;
            transition: background 200ms;
            &--disabled {
              opacity: 0.65;
              cursor: not-allowed;
            }

            &__wrapper input:focus-visible + .toggle {
              box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.6);
            }

            &__thumb {
              position: absolute;
              height: 16px;
              width: 16px;
              border-radius: 50%;
              background: white;
              cursor: pointer;
              left: 0;
              top: 50%;
              transform: translate(0, -50%);
              transition: transform 200ms;
              &--checked {
                transform: translate(80%, -50%);
              }
            }
          }

          .screen-readers-only {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border-width: 0;
          }
        `}
      </style>
    </label>
  )
}
